"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Caption = void 0;
const React = require("react");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles);
const Caption = ({ title, description = "" }) => (React.createElement("div", { className: css("caption") },
    title && (React.createElement("div", { "data-test": "title", className: css("caption_title") }, title)),
    description && (React.createElement("div", { "data-test": "description", className: css("caption_description") }, description))));
exports.Caption = Caption;
//# sourceMappingURL=index.js.map